<template>
  <div class="ProjectIntroduction">
    <!-- <div class="banner">
      <span>双推双促工程简介</span>
    </div> -->
    <div class="content" v-html="summary.profile">
      
      <!-- <el-card class="box-card" shadow="hover">
        <div class="contentDescription">
          为充分发挥中华国际科学交流基金会院士、杰出工程师等高端智力资源优势，探索以科技公益方式构建国家科技成果转化专业化及社会化服务体系，促进培育发展新质生产力，2024年，中华国际科学交流基金会（以下简称：科基会）与中关村天合科技成果转化促进中心共同组织发起科技成果转化“双推双促工程”（推成果、推需求、促转化、促落地），旨在破解科技成果转化“最后一公里”难题，促进推动科技成果向现实生产力高效转化，助力实现国家及地方实体经济高质量发展。
        </div>
        <div class="contentDescription">
          “双推双促工程”锚定技术创新与产业创新深度融合目标，构建“入围-提名-优胜”三级筛选机制，致力于从海量科技成果中挖掘重大优秀科技成果转化项目。其中：“双推”为推成果（筛选优质技术）、推需求（对接产业与地方政府需求）；“双促”为促转化（专业赋能）、促落地（园区/资本对接）。
        </div>
        <div class="contentDescription">
          “双推双促工程”的目标是发挥科技公益平台和专业化转化能力优势，发现和挖掘、促进和促成一批“中间态的优秀科技成果产业化落地项目”。“双推双促工程”的定位是形成“公益赋能+市场运作”双轮驱动模式，探索打造国家级科技成果转化生态赋能协同机制。“双推双促工程”的服务模式是全周期科技赋能，贯彻从项目遴选、技术评估、商业建模、融资对接、园区落地等全链条服务
        </div>
        <div class="contentDescription">
          科基会联合全国性重点行业协会、专业学会、高校、科研院所及院士、杰出工程师等多方力量组织实施“双推双促工程”，充分发挥各自资源优势，共同搭建起专业化、社会化的科技成果转化服务平台，推动项目落地生根，为各行业、各地区的科技成果产业化发展注入强劲动能。
        </div>
</el-card>

<div class="mainTitle">
  双推双促工程组织架构
</div>
<div>
  <el-card class="box-card" shadow="hover">
  <div slot="header" class="clearfix">
    <span>一、机构设置</span>
  </div>
  <div class="jjContentImgDiv">
    <img src="@/assets/jjContent.jpg" class="jjContentImg" alt="">
  </div>
</el-card>
</div>
<div>
  <el-card class="box-cardContent" shadow="hover">
        <div class="dsgTitle">
          二、工程办公室管理团队
        </div>
        <div class="dsgContent">
          主 任：刘二东、朱楠
        </div>
        <div class="dsgContent">
          副主任：李猛、朱微微、潘文龙、余军
        </div>
        <div class="dsgContent">
          成 员：辛妍、杨梅、周银芝、张悦、王晶晶
        </div>

</el-card>
<el-card class="box-cardContent" shadow="hover">
        <div class="dsgTitle">
          三、联系方式
        </div>
        <div class="dsgContent">
          北京市海淀区澄湾街19号院1号楼218室
        </div>
        <div class="dsgContent">
          联系人：杨梅，18701397959
        </div>
        <div class="dsgContent">
          北京市西城区月坛南街59号新华大厦508室
        </div>
        <div class="dsgContent">
          联系人：张悦，18301150902
        </div>

</el-card> -->
<!-- </div> -->
    </div>
  </div>
</template>

<script>

export default {
  name: "ProjectIntroduction",
  data() {
    return {
      summary:{}
    };
  },
  mounted() {
    this.getSummary()
  },

  methods: {
    getSummary() {
      this.$API.getSummary({type:1}).then(res => {
        this.summary = res.data;
      })
    }
}
}
</script>

<style scoped lang="scss">
  ::v-deep .content img{
        max-width: 100%;
        height: auto;
        display: block;
        object-fit: contain;
  }
.box-cardContent{
  margin-top: 30px;
}
.dsgContent{
  color: rgba(0, 0, 0, .45);
  font-size: 14px;
  margin-top: 15px;
}
.dsgTitle{
  overflow: hidden;
    color: rgba(0, 0, 0, .85);
    font-weight: 500;
    font-size: 16px;
    white-space: nowrap;
    text-overflow: ellipsis;
}
.jjContentImgDiv{
  display: flex;
  justify-content: center;
}
.jjContentImg{
  margin-top: 50px;
    margin-bottom: 50px;
    width: 1200px;
    vertical-align: middle;
    border-style: none;
}
.mainTitle{
  font-size: 40px;
    margin-top: 50px;
    margin-bottom: 50px;
    text-align: center;
}
::v-deep .el-card__header{
  padding-left: 0 !important;
  padding-right: 0 !important;
}
::v-deep .clearfix span{
  overflow: hidden;
    color: rgba(0, 0, 0, .85);
    font-weight: 500;
    font-size: 16px;
    white-space: nowrap;
    text-overflow: ellipsis;
    padding-left: 24px;
}

.contentDescription{
  font-size: 20px;
    font-family: Arial, Helvetica, sans-serif;
    text-indent: 2em;
    letter-spacing: 1px;
    line-height: 40px;
    color: rgba(0,0,0,.45);
    margin-top: 20px;
}
.banner{
  position: relative;
    z-index: 2;
    overflow: hidden;
    background: #000;
    display: -webkit-flex;
    display: flex;
    -webkit-justify-content: center;
    justify-content: center;
    background-image: url('../../assets/tjdwBanner.png');
    background-repeat: no-repeat;
    background-position: 50%;
    width: 100%;
    min-height: 350px;
    -webkit-align-items: center;
    align-items: center;
    span{
      color: #fff;
    letter-spacing: 5px;
    font-size: 50px;
    text-align: center;
    }
}
.ProjectIntroduction{
  background: #fff;
  cursor: pointer;
}
.content{
  width: 1200px;
    margin: 0 auto;
    padding-top: 30px;
    padding-bottom: 30px;
    display: -webkit-flex;
    display: flex;
    -webkit-flex-direction: column;
    flex-direction: column;
    -webkit-justify-content: center;
    justify-content: center;
    background-color: #fff;
}
.main_title{
  font-size: 32px;
    text-align: center;
    height: 40px;
    color: #5c5c5c;
}
</style>
